import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import './DashboardStudyItem.scss';
import { AccessibilityContext } from '../../store/accesibility-context';

import { Icon } from '@mui/material';

const DashboardStudyItem = ({
	color,
	status,
	id,
	type,
	title,
	sponsor,
	username,
	docUpload,
	role,
	warning
}) => {
	const navigate = useNavigate();
	const accessibilityCtx = useContext(AccessibilityContext);

	const colorStyle = `linear-gradient(180deg, ${color} 4rem, #fff 0%)`;

	const studyItemClickHandler = (studyId) => {
		const studyItemRoute = `${studyId}`;
		navigate(studyItemRoute);
	};

	return (
		<div
			className={`${accessibilityCtx.font_Size ? 'study-item-font' : 'study-item'}`}
			// className='study-item'
			style={{ background: colorStyle }}
			onClick={() => studyItemClickHandler(id)}
		>
			<div className='study-title-box'>
				<div>{status}</div>
				{warning !== '' && (
					<Icon className='study-title-icon'>warning</Icon>
				)}
			</div>

			<div className='study-detail-container'>
				<p className='title-type'>{title}</p>
				<p>{`Type: ${type}`}</p>
				<p>{`Sponsor: ${sponsor}`}</p>
				<p>{`${role}: ${username}`}</p>
				<p>{`Documents Uploaded: ${docUpload}`}</p>
			</div>
		</div>
	);
};

export default DashboardStudyItem;
